import { CFTokens } from '../../../../tokens';
export const BORDER_RADIUS = {
    DEFAULT: CFTokens.BORDER_RADIUS.A,
    ROUNDED: 100,
};
